import styled from '@emotion/styled';

const PriceBoxWrapper = styled.div`
  background-color: white;
  padding: 0 16px;
  position: relative;
  z-index: 100;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    display: block;
  }

  &.collapsed {
    padding: 0;
    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      display: none;
    }
    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      display: block;
    }

    .min-max-price {
      display: none;
      @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
        display: block;
      }
    }

    .prices {
      flex-direction: row;
      border: none;
      @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
        flex-direction: column;
        border: 1px solid ${(props) => props.theme.colors.line};
      }
    }

    .bottom-section {
      display: none;
      @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
        display: flex;
      }
    }

    .divider {
      width: 1px;
      height: 50px;
      margin: calc(${(props) => props.theme.padding} / 2);
      @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
        width: 100%;
        height: 1px;
        margin: calc(${(props) => props.theme.padding} / 2);
      }
    }

    .icon img {
      width: 30px;
      height: 30px;
      @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
        width: 51px;
        height: 51px;
      }
    }

    .price-box {
      margin-left: 10px;
      min-width: auto;
      @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
        margin-left: 20px;
      }
    }
  }

  .price-title {
    margin-top: 24px;
    text-align: center;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      margin-top: 32px;
    }
  }

  .price-value {
    font-weight: bold;
    text-align: center;
    margin-bottom: 16px;
    margin-top: 8px;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      margin-top: 12px;
      margin-bottom: 24px;
    }
  }

  .expand-box {
    display: flex;
    background: white;
    color: #004b54;
    align-items: center;
    flex-direction: column;
    text-align: center;
    line-height: 24px;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      background: ${(props) => props.theme.colors.grey._100};
      flex-direction: row;
      line-height: 30px;
      padding: 24px;
      text-align: left;
    }

    .CTA {
      padding: 1em;
      margin-top: 16px;

      @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
        min-width: 276px;
        margin-top: 0;
      }
    }
  }

  .prices {
    display: flex;
    border-radius: 7px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid ${(props) => props.theme.colors.line};
    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      flex-direction: row;
    }
    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      flex-direction: column;
    }
  }

  .price-box-item {
    display: flex;
    align-items: center;
    padding: ${(props) => props.theme.padding} 0;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      width: 230px;
      &:nth-of-type(1) {
        padding-bottom: 15px;
      }
      &:nth-of-type(3) {
        padding-top: 10px;
      }
    }
    @media (max-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      justify-content: center;
    }
  }

  &:not(.collapsed) {
    .price-box-item {
      @media (max-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
        &:nth-of-type(1) {
          padding-bottom: 15px;
        }
        &:nth-of-type(3) {
          padding-top: 10px;
        }
      }
    }
  }

  .divider {
    background: ${(props) => props.theme.colors.line};
    width: 100%;
    height: 1px;
    margin: calc(${(props) => props.theme.padding} / 2);
    @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
      width: 1px;
      height: 50px;
      margin-left: 60px;
      margin-right: 60px;
    }
    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      width: 100%;
      height: 1px;
      margin: calc(${(props) => props.theme.padding} / 2);
    }
  }

  .icon img {
    width: 51px;
    height: 51px;
  }

  .price-box {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    min-width: 155px;
    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      .short-label {
        display: none;
      }
      .label-apartment {
        display: block !important;
      }
    }
  }

  .bottom-section {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;

    .stand-date {
      opacity: 0.54;
      color: #000000;
      font-family: Roboto;
      font-size: 12px;
      font-style: italic;
      line-height: 14px;
    }

    .report-link {
      opacity: 0.54;
      color: #000000;
      font-family: Roboto;
      font-size: 12px;
      line-height: 14px;
      text-decoration: underline;
    }
  }

  .title {
    color: #4a4a4a;
    font-family: Roboto;
    font-size: 14px;
    line-height: 16px;

    &.collapsed .short-label {
      opacity: 0.54;
      color: #4a4a4a;
      font-family: Roboto;
      font-size: 12px;
      line-height: 14px;
    }
  }

  .average-price {
    color: #4a4a4a;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    margin: 5px 0;
  }

  .min-max-price {
    opacity: 0.54;
    color: #4a4a4a;
    font-family: Roboto;
    font-size: 12px;
    line-height: 14px;
  }
`;

export { PriceBoxWrapper };
